import React, { Component } from 'react';
import stringSimilarity from 'string-similarity';
import { Picker } from 'emoji-mart';
import { showErrorPopup } from '../../popups/ErrorPopup/ErrorPopup';
import { GLADLY, GENESYS, ZENDESK, ZENDESK_CHAT, GORGIAS, EMAIL_MESSAGE } from '../../../constants/conversationTypes';
import {
  MESSAGE_SIZE_LIMIT,
  GLADLY_MESSAGE_SIZE_LIMIT,
  GENESYS_OUTBOUND_MESSAGE_NUMBER_LIMIT,
} from '../../../constants/limits';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';
import { BUTTON_IDS } from '../../../reducers/ui/buttons';
import { checkHasGreeting, htmlToText, messageToClientFormat, doesContainEmojis } from '../../../util';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import {
  trackSmbCategoriesLoadedValueChange,
  trackTicketSwitchWhileFetchingSmbCategories,
  trackNoMappingForSimplrTag,
  trackPartnerTaggingPopupTriggered,
  trackAbortedNameOverride,
  trackBlockedNameOverride,
} from '../../../analytics/ticketEventAnalytics';
import { trackMultiIntentWarningDisplayed } from '../../../analytics/mlEventAnalytics';
import { trackNoScrollBlock, trackMessageWindowSizeChange } from '../../../analytics/screenEventAnalytics';
import {
  DEFAULT_FIRST_GREETING,
  DEFAULT_SECOND_GREETING,
  FIRST_NAME_PLACEHOLDER,
  EDITOR_USAGE_REPLY,
  AUTO_TRANSLATED_EDITOR_USAGE_REPLY,
  ErrorStrings,
} from '../../../constants/fixedMessages';
import { MASK_CHAR as COUPON_MASK_CHAR } from '../../../containers/tools/SearchPage/AddCouponCodeButtonContainer';
import { openPartnerTaggingPopup } from '../../popups/PartnerTaggingPopup/PartnerTaggingPopup';
import { getTextFromPTagRegex } from 'constants/regex';
import NewMessageWarningPopup from '../NewMessageWarningPopup/NewMessageWarningPopup';
import { INBOUND, OUTBOUND } from 'constants/messageDirection';
import { ERROR } from 'constants/messageStatuses';
import * as MessageTypes from '../../../constants/messageTypes';
import { getDefaultKeyBinding } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { DraftHelpers } from '../../../util/Draft';
import * as KeyboardCode from '../../../constants/keyboardCodes';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import openOnTextPastePopup from '../../popups/OnTextPastePopup/OnTextPastePopup';
import openOnTextPasteImageLinkRemoved from '../../popups/OnTextPasteImageLinkRemoved';
import { BotDialogBlockedWords, BotDialogOverridableWords } from 'components/BotDialog';
import { SPECIALIST_ONLY_HINT } from 'constants/noteTypes';
import { SMB_BOT } from 'constants/sources';
import { showErrorMessage } from '../../../util/errorPopupUtil';
import {
  cookConversationMessagesForPredictionAPI,
  checkIfPredictionIsTurnedOn,
  getPredictionTextViaApi,
  removePredictionText,
  appendPredictionTextToContents,
  editorAllowUndoTurnOff,
  editorAllowUndoTurnOn,
  checkFocusOnLastBlockEnd,
  DEFAULT_DEBOUNCE_AMOUNT_FOR_GET_PREDICTION_TEXT,
} from 'util/predictionUtils';
import CWNotification from '../../CenterInfoPanel/CommerceWizard/CWNotification/CWNotification';
import { isAutoTaggingAvailable, setAutoTags } from 'api/partnerTags';
import { getGlobalParseConfigsList } from 'api/platformConfig';
import ChatUI from '../../ChatUI/ChatUI';
import { isLiveChat } from 'util/chat';
import {
  ErrorMessage,
  MessageBox,
  EmojiContainer,
  Wrapper,
  BottomNotice,
  BusinessReminder,
  MessageForm,
  BottomSection,
  FlexFill,
  Emoji,
  EmojiIcon,
  IconContainer,
  TextareaHolder,
  TextareaBoxOuter,
  ExpandIcon,
  SendButton,
  BottomNoticeText,
} from './NewMessage.styles';
import * as ErrorService from 'services/ErrorService/ErrorService';
import { handleError } from 'services/ErrorService/ErrorService';
import ClickOutside from '../../common/ClickOutside/ClickOutside';
import GrammarlyEditorWrapper from '../../../wrappers/GrammarlyEditorWrapper';
import GrammarlyButtonWrapper from '../../../wrappers/GrammarlyButtonWrapper';

const MESSAGE_SIZE_LIMIT_MAP = {
  [GLADLY]: GLADLY_MESSAGE_SIZE_LIMIT,
};

const OUTBOUND_MESSAGE_NUMBER_LIMIT_MAP = {
  [GENESYS]: GENESYS_OUTBOUND_MESSAGE_NUMBER_LIMIT,
};

const NEEDS_TAGGING_AFTER_NUMBER_OF_MSGS = 2; // counting from 0 so 2 means three msgs

class NewMessage extends Component {
  static warningMessageMultiIntent = {
    text: 'Notice this ticket contains multiple questions. Please carefully review and respond accordingly.',
    iconName: 'MultipleQuestions_icon.svg',
  };

  static warningMessageIdenticalReply = {
    text: "Attention - A similar message was previously sent to the customer, please review the message thread again to understand the customer's issue and send a correct reply.",
    iconName: 'Warning.svg',
  };

  static warningMessageContainsEmojis = {
    text: 'Attention - This partner has disabled emojis, please remove emojis before sending',
    iconName: 'Warning.svg',
  };

  static KEY_CMD_SEND_MESSAGE = 'send-message';

  constructor(props) {
    super(props);
    this.state = {
      universalBlackListedWords: [],
      universalBlackListedCussWords: [],
      universalBlackListedRegexes: {},
      showEmoji: false,
      emojiActive: false,
      lengthError: false,
      textAreaExpanded: false,
      placeholderError: false,
      partnerTagsAreLoaded: false,
      skipSimilarityCheck: false,
      warningMessage: { text: '', iconName: '' },
      disableMultiIntentWarningMessage: false,
      conversationToAddNote: null,
      predictionTextIsTurnedOn: false,
      inputText: null,
      predictionText: '',
      confirmedOverridableWords: [],
    };
    this.setDomEditorRef = (ref) => (this.domEditor = ref);
    this._isMounted = false;
    const debounceAmountForGetPredictionText =
      this.props.debounceAmountForGetPredictionText || DEFAULT_DEBOUNCE_AMOUNT_FOR_GET_PREDICTION_TEXT;
    this.getPredictionText = debounce(this.getPredictionText, debounceAmountForGetPredictionText, {
      trailing: true,
    });
  }

  setChatMacroRecommendationsEnabled = (enabled) => {
    this.props.setChatMacroRecommendationsEnabled(enabled);
  };

  async componentDidUpdate(prevProps, prevState) {
    const { ticket: prevSelectedTicket } = prevProps;
    const { ticket: selectedTicket } = this.props;

    if (this.predictionIsTurnedOn() && this.hasPredictionText()) {
      const { predictionText: oldPredictionText } = prevState;
      const { predictionText: newPredictionText } = this.state;
      if (oldPredictionText !== newPredictionText) {
        const { decisionTreeCouponCode } = this.props.selectedUnSentMessage;
        const editorState = appendPredictionTextToContents(
          oldPredictionText,
          newPredictionText,
          this.props.editorState
        );
        this.props.saveNewMessageEditorState(
          selectedTicket.ticketId,
          editorAllowUndoTurnOff(editorState),
          decisionTreeCouponCode
        );
      }
    }
    if (get(prevSelectedTicket, 'ticketId') !== get(selectedTicket, 'ticketId')) {
      // if ticket has been switched, reload
      await this._loadPartnerTagsAndBlacklists();
    }

    const oldId = get(prevProps, 'ticket.simplrAccountPtrId', null);
    const newId = get(this.props, 'ticket.simplrAccountPtrId', null);

    if (oldId !== newId && newId) {
      await this.handlePredictionTextActivation();
    }

    const grammarlyArray = document.getElementsByTagName('grammarly-extension');

    if (!this.state.warningMessage.text) {
      if (grammarlyArray.length) {
        grammarlyArray[0].style.zIndex = '2';
      }
    } else {
      if (grammarlyArray.length) {
        grammarlyArray[0].style.zIndex = '1';
      }
    }

    const previousMessagesCount = prevProps.currentConversation && prevProps.currentConversation.allMessages.length;
    const currentMessagesCount = this.props.currentConversation && this.props.currentConversation.allMessages.length;

    if (previousMessagesCount < currentMessagesCount) {
      try {
        if (this.domEditor && typeof this.domEditor.focus === 'function') {
          this.domEditor.focus();
        }
      } catch (error) {
        handleError({ error });
      }
    }
  }

  async componentDidMount() {
    this._isMounted = true;
    await this._loadPartnerTagsAndBlacklists();
    await this.handlePredictionTextActivation();
  }

  async handlePredictionTextActivation() {
    this.setState({ predictionTextIsTurnedOn: false });
    const { allowPredictionTextConfig } = await getGlobalParseConfigsList(['allowPredictionTextConfig']);
    const currentPartnerId = this.getSimplrAccountObjectId();
    const currentExpertId = this.props.user.id;
    if (
      allowPredictionTextConfig &&
      checkIfPredictionIsTurnedOn(allowPredictionTextConfig, currentExpertId, currentPartnerId)
    ) {
      this.setState({ predictionTextIsTurnedOn: true });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async _loadPartnerTagsAndBlacklists() {
    const ticket = this.props.ticket;
    const originalTicketId = this.props.ticketId;
    const ticketHasPartnerTags = ticket && !isEmpty(ticket.platformTags);
    const isTicketLiveChat = ticket && isLiveChat(ticket.communicationType);

    // reset for ticket switches
    this.setState({ partnerTagsAreLoaded: false });

    this.props.loadBusinessAlertsForAccount();

    let partnerTagsAreLoaded;
    let analyticsParams = {};
    if (!ticket || Object.keys(ticket).length === 0) {
      analyticsParams.reasonForValue = 'Ticket undefined';
      partnerTagsAreLoaded = false;
    } else if (isTicketLiveChat || ticketHasPartnerTags) {
      analyticsParams.reasonForValue = 'Ticket is live chat or has partner tags';
      partnerTagsAreLoaded = true;
    } else {
      analyticsParams.reasonForValue = 'Ticket is not live chat and needs to fetch tags';
      partnerTagsAreLoaded = await this.props.loadPartnerTags();
    }

    // Track what value partnerTagsAreLoaded was set to for the ticket
    analyticsParams.smbCategoriesAreLoadedValue = partnerTagsAreLoaded;
    analyticsParams.ticketHasPartnerTags = ticketHasPartnerTags;
    analyticsParams.isTicketLiveChat = isTicketLiveChat;
    trackSmbCategoriesLoadedValueChange(analyticsParams);

    const {
      blackListedWords: universalBlackListedWords,
      blackListedCussWords: universalBlackListedCussWords,
      blackListedRegexes: universalBlackListedRegexes,
    } = await getGlobalParseConfigsList(['blackListedWords', 'blackListedCussWords', 'blackListedRegexes']);

    const currentTicketId = this.props.ticketId;
    const stillOnOriginalTicket = originalTicketId === currentTicketId;

    if (this._isMounted === true && stillOnOriginalTicket) {
      this.setState({
        partnerTagsAreLoaded,
        universalBlackListedWords,
        universalBlackListedCussWords,
        universalBlackListedRegexes,
      });
    } else {
      trackTicketSwitchWhileFetchingSmbCategories({
        originalTicketId,
        currentTicketId,
      });
      this.setState({
        universalBlackListedWords,
        universalBlackListedCussWords,
        universalBlackListedRegexes,
      });
    }
  }

  async validateMessageOnLength(text, messageSizeLimit = MESSAGE_SIZE_LIMIT) {
    if (text.length > messageSizeLimit) {
      await this.setState({ lengthError: true });
    } else {
      await this.setState({ lengthError: false });
    }
  }

  validateOutboundMessageNumber(messageNumberLimit) {
    if (!messageNumberLimit) {
      return false;
    }

    const { currentConversation } = this.props;

    if (!currentConversation) {
      return false;
    }

    let messageNumber = 0;
    const { allMessages } = currentConversation;

    const messages = allMessages
      .map((id) => ({
        direction: get(currentConversation, `${id}.direction`),
        status: get(currentConversation, `${id}.status`),
        source: get(currentConversation, `${id}.source`),
      }))
      .reverse();

    for (const message of messages) {
      if (message.direction === INBOUND) {
        break;
      }

      if (message.direction === OUTBOUND && message.status !== ERROR && message.source !== SMB_BOT) {
        messageNumber += 1;
      }
    }

    return messageNumber >= messageNumberLimit;
  }

  predictionIsTurnedOn = () => this.state.predictionTextIsTurnedOn;

  hasPredictionText = () => this.state.predictionText.length > 0;

  removePredictionTextEvent() {
    if (!this.hasPredictionText() || !this.predictionIsTurnedOn()) {
      return null;
    }
    const { editorState } = this.props;
    const ticketId = this.props.selectedTicketId;
    const { decisionTreeCouponCode } = this.props.selectedUnSentMessage;
    const newEditorState = this.removePredictionText(editorState);
    this.props.saveNewMessageEditorState(ticketId, editorAllowUndoTurnOff(newEditorState), decisionTreeCouponCode);
  }

  savePredictionTextEvent() {
    if (!this.hasPredictionText() || !this.predictionIsTurnedOn()) {
      return null;
    }
    const { predictionText } = this.state;
    this.insertTextIntoMessage(predictionText);
  }

  removePredictionText(editorState) {
    if (this.hasPredictionText()) {
      editorState = removePredictionText(this.state.predictionText, editorState);
      this.setState({ predictionText: '' });
    }

    return editorState;
  }

  getPredictionText(prefix) {
    const conversationId = get(this.props, 'message.conversationObjectId', null);
    const businessId = this.getSimplrAccountObjectId();
    const messages = cookConversationMessagesForPredictionAPI(this.props.currentConversation);
    if (prefix.length > 0) {
      getPredictionTextViaApi(conversationId, businessId, prefix, messages).then((predictionTextObj) => {
        if (predictionTextObj && predictionTextObj.completion) {
          this.setState({ inputText: prefix, predictionText: predictionTextObj.completion });
        }
      });
    }
  }

  handleTextChangeEvent(editorState) {
    if (this.props.isCommerceWizardActive && !isLiveChat(this.props.ticket.communicationType)) {
      return;
    }

    const ticketId = this.props.selectedTicketId;
    this.setState({ lengthError: false });
    const { decisionTreeCouponCode } = this.props.selectedUnSentMessage;

    if (this.predictionIsTurnedOn()) {
      const focusOnLastBlockEnd = checkFocusOnLastBlockEnd(this.state.predictionText, editorState);
      const oldContentText = this.props.editorState.getCurrentContent().getPlainText();
      const newContentText = editorState.getCurrentContent().getPlainText();
      if (this.hasPredictionText()) {
        editorState = this.removePredictionText(editorState);
      }
      if (newContentText !== oldContentText && focusOnLastBlockEnd) {
        this.getPredictionText(editorState.getCurrentContent().getPlainText(), editorState);
      }
      editorState = editorAllowUndoTurnOn(editorState);
    }

    this.props.saveNewMessageEditorState(ticketId, editorState, decisionTreeCouponCode);

    const messageSizeLimit = MESSAGE_SIZE_LIMIT_MAP[this.props.message.messageType];
    const { ticket } = this.props;
    const isChat = ticket && isLiveChat(ticket.communicationType);
    if (messageSizeLimit && isChat) {
      const unSentHtmlMessage = DraftHelpers.contentToHtml(editorState.getCurrentContent());
      const unSentTextMessage = htmlToText(unSentHtmlMessage);
      this.validateMessageOnLength(unSentTextMessage, messageSizeLimit);
    }

    const grammarlyArray = document.getElementsByTagName('grammarly-extension');
    if (grammarlyArray.length && !this.state.warningMessage.text) {
      grammarlyArray[0].style.zIndex = '2';
    }
  }

  insertTextIntoMessage(insertText) {
    let { editorState, ticket } = this.props;
    this.setState({ lengthError: false });
    const { decisionTreeCouponCode } = this.props.selectedUnSentMessage;
    const messageSizeLimit = MESSAGE_SIZE_LIMIT_MAP[this.props.message.messageType];
    const isChat = ticket && isLiveChat(ticket.communicationType);
    if (messageSizeLimit && isChat) {
      const unSentHtmlMessage = DraftHelpers.contentToHtml(editorState.getCurrentContent());
      const unSentTextMessage = htmlToText(unSentHtmlMessage);
      this.validateMessageOnLength(unSentTextMessage, messageSizeLimit);
    }
    editorState = DraftHelpers.replaceCurrentSelection(insertText, editorState);
    this.props.saveNewMessageEditorState(this.props.ticket.ticketId, editorState, decisionTreeCouponCode);
  }

  showMultiIntentWarning = () => {
    // Show Multi-intent warning only ...
    // * once,
    // * if ML service identifies it as a multi-intent message,
    // * it is a reply to the first message in the thread.
    const { allMessages: allMessagesIds } = this.props.currentConversation;
    if (
      !this.state.disableMultiIntentWarningMessage &&
      this.props.multiIntentClassification === MessageTypes.MULTI_INTENT &&
      Array.isArray(allMessagesIds) &&
      allMessagesIds.length === 1
    ) {
      this.setState({ warningMessage: NewMessage.warningMessageMultiIntent });
      trackMultiIntentWarningDisplayed();

      return true;
    }

    return false;
  };

  // Note: every return path from this function must set state of setBtnActivity to true.
  async submitMessage(buttonId, conversationId, lastSimplrMessageBody) {
    const {
      checkGreeting,
      hasExpertReplied,
      message,
      messagesViewed,
      scrollRequirementMet,
      getEditorStateFromId,
      ticket,
    } = this.props;

    if (!ticket) {
      return showErrorMessage(ErrorStrings.COUND_NOT_FIND_TICKET_FOR_MESSAGE);
    }

    // block send if user has not scrolled to bottom of conversation - will not display twice
    if (!messagesViewed) {
      trackNoScrollBlock();
      showErrorPopup(
        `It looks like you didn't read the entire message chain. Please scroll to the bottom of the conversation before responding.`,
        'Oops!'
      );

      return scrollRequirementMet();
    }

    const unSentHtmlMessage = DraftHelpers.contentToHtml(getEditorStateFromId(conversationId).getCurrentContent());
    const unSentTextMessage = htmlToText(unSentHtmlMessage);

    if (this.props.disableEmojis && doesContainEmojis(unSentTextMessage)) {
      this.setState({ warningMessage: NewMessage.warningMessageContainsEmojis });

      return;
    }

    this.setState({ showEmoji: false, emojiActive: false });
    const { conversationObjectId } = message;
    const messageSizeLimit = MESSAGE_SIZE_LIMIT_MAP[this.props.message.messageType];

    if (messageSizeLimit && isLiveChat(ticket.communicationType)) {
      // setState does not change value immediately. We read this.state.lengthError just after setState().
      await this.validateMessageOnLength(unSentTextMessage, messageSizeLimit);
    }

    const outboundMessageNumberLimit = OUTBOUND_MESSAGE_NUMBER_LIMIT_MAP[this.props.message.messageType];
    if (this.validateOutboundMessageNumber(outboundMessageNumberLimit)) {
      return showErrorPopup(`For this ticket, Message number is limited to ${outboundMessageNumberLimit} message(s).`);
    }

    if (this.state.lengthError) {
      const sizeLimit = MESSAGE_SIZE_LIMIT_MAP[this.props.message.messageType] || MESSAGE_SIZE_LIMIT;

      return showErrorPopup(`For this ticket, Message size is limited to ${sizeLimit} characters.`);
    }

    if (!unSentTextMessage.replace(/\s/g, '').length) {
      this.setState({ placeholderError: true });
    }

    if (unSentTextMessage.replace(/\s/g, '').length) {
      let greetingError =
        checkGreeting && (hasExpertReplied && !DEFAULT_SECOND_GREETING ? false : !checkHasGreeting(unSentHtmlMessage));
      if (greetingError) {
        SessionAnalyticsService.event('Greeting Missing', {
          ticket: conversationObjectId,
          smbName: message.smbName,
        });

        const expectedGreeting = htmlToText(hasExpertReplied ? DEFAULT_SECOND_GREETING : DEFAULT_FIRST_GREETING);

        return showErrorPopup(
          `Please do not modify the greeting "${expectedGreeting}" except by replacing ${FIRST_NAME_PLACEHOLDER} with the customer's first name or "there" if no name can be found. White space and punctuation need to match exactly and a new paragraph is required after the greeting.`,
          'Message Error'
        );
      }

      const { allMessages: allMessagesIds, selectedConversationId, ...messages } = this.props.currentConversation;
      // check if conversation has similar messages
      const isSimilar = this.checkSimilarity(
        unSentTextMessage,
        allMessagesIds,
        messages,
        this.state.skipSimilarityCheck
      );
      if (!isSimilar) {
        const macroCouponCodeTypeId =
          unSentTextMessage && unSentTextMessage.includes(COUPON_MASK_CHAR) ? this.props.macroCouponCodeTypeId : null;
        await this.props.onSendMessage(
          this.props.message,
          unSentHtmlMessage,
          buttonId,
          conversationId,
          lastSimplrMessageBody,
          macroCouponCodeTypeId,
          this.state.confirmedOverridableWords
        );
        // reset skipSimilarityCheck flag to false when message sent
        this.setState({ placeholderError: false, skipSimilarityCheck: false });
      } else {
        // show warning popup
        this.setState({ warningMessage: NewMessage.warningMessageIdenticalReply });

        return;
      }
    }

    // Collapse message area when clicking send message
    if (this.props.textAreaExpanded) {
      this.props.onExpandClick();
    }
  }

  onExpandClick() {
    this.props.onExpandClick();
  }

  onClickOutsideEmojiHandler = () => {
    if (this.state.showEmoji) {
      this.setState({ showEmoji: false, emojiActive: false });
    }
  };

  onClickEmojiIconHandler = () => {
    // disabled when commerce wizard is active for an email ticket
    if (
      !this.state.showEmoji &&
      !(this.props.isCommerceWizardActive && !isLiveChat(this.props.ticket.communicationType))
    ) {
      this.setState({ showEmoji: true, emojiActive: true });
    }
  };

  getSelectedSimplrTag() {
    const tagHistory = get(this.props.ticket, 'tagHistory', null);
    const tag = get(last(tagHistory), 'simplrTag', null);

    if (tag) {
      return this.props.simplrTags.includes(tag) ? tag : null;
    }

    return null;
  }

  async handleAutoTagging(buttonId, conversationId, lastSimplrMessageBody) {
    const selectedSimplrTag = this.getSelectedSimplrTag();
    const ticket = this.props.ticket;

    try {
      this.props.setBtnActivity(buttonId, false);
      const isTaggingAvailable = await isAutoTaggingAvailable(ticket, selectedSimplrTag);
      if (!isTaggingAvailable) {
        if (ticket.communicationType === EMAIL_MESSAGE && [ZENDESK, GORGIAS].includes(ticket.ticketType)) {
          this.props.setBtnActivity(buttonId, true);

          return this.showPartnerTaggingPopup();
        }
        trackNoMappingForSimplrTag(conversationId, selectedSimplrTag);
      } else {
        try {
          await setAutoTags(ticket, selectedSimplrTag);
        } catch (error) {
          ErrorService.handleError({
            error,
            customMessage: `Error updating platformTags for ticket ${ticket.ticketId}`,
          });
        }
      }
    } catch (error) {
      ErrorService.handleError({
        error,
        customMessage: `Error checking isAutoTaggingAvailable for ticket ${ticket.ticketId}`,
      });
    }

    this.props.setBtnActivity(buttonId, true);

    return await this.submitMessage(buttonId, conversationId, lastSimplrMessageBody);
  }

  async taggingManager(buttonId, conversationId, lastSimplrMessageBody) {
    const ticketType = get(this.props.ticket, 'ticketType');
    switch (ticketType) {
      case ZENDESK:
      case GORGIAS:
      case ZENDESK_CHAT:
        return await this.handleAutoTagging(buttonId, conversationId, lastSimplrMessageBody);
      default:
        return this.showPartnerTaggingPopup();
    }
  }

  showPartnerTaggingPopup() {
    const conversationId = get(this.props.ticket, 'ticketId');
    const lastSimplrMessageBody = this.props.lastSimplrMessageBody;
    const buttonId = BUTTON_IDS.sendMessageBtn;
    // Track when partner tagging popup appears for a ticket
    trackPartnerTaggingPopupTriggered(conversationId);

    return openPartnerTaggingPopup(
      async () => await this.submitMessage(buttonId, conversationId, lastSimplrMessageBody),
      () => {
        this.props.setBtnActivity(BUTTON_IDS.sendMessageBtn, true);
      }
    );
  }

  countSentSimplrMsgs() {
    const allMessages = this.props.allMessages || [];
    const simplrMessages = Object.values(allMessages).filter(
      (message) => message.source === 'SIMPLR' && message.direction === 'OUTBOUND' && message.status !== 'ERROR'
    );

    return simplrMessages.length;
  }

  checkHasNoSelectedTag(ticket) {
    const tagHistory = get(ticket, 'tagHistory', null);
    const firstTag = get(tagHistory, '0.simplrTag', null);
    if (!firstTag) {
      return true;
    }
    const simplrTags = this.props.simplrTags || [];
    if (!simplrTags.includes(firstTag)) {
      // if first tag is not SimplrTag we are checking second tag
      // second tag is always SimplrTag or null
      return !get(tagHistory, '1.simplrTag', null);
    }

    return false;
  }

  checkIsTaggingRequired() {
    const ticket = this.props.ticket;

    return (
      !this.props.disableSimplrTaggingRequired &&
      this.countSentSimplrMsgs() >= NEEDS_TAGGING_AFTER_NUMBER_OF_MSGS &&
      this.checkHasNoSelectedTag(ticket)
    );
  }

  async checkIfTaggingNeededThenSendMessage() {
    const ticket = this.props.ticket;

    if (this.checkIsTaggingRequired()) {
      return showErrorPopup(`Please go to actions and select a category to continue sending messages`, 'Oops!');
    }

    const conversationId = ticket.ticketId;
    const lastSimplrMessageBody = this.props.lastSimplrMessageBody;
    const buttonId = BUTTON_IDS.sendMessageBtn;
    if (this.props.smbTaggingActive) {
      return await this.taggingManager(buttonId, conversationId, lastSimplrMessageBody);
    }

    return this.submitMessage(buttonId, conversationId, lastSimplrMessageBody);
  }

  handleSendMessage({ bypassButtonState = false } = {}) {
    if (this.isSendButtonDisabled() && !bypassButtonState) {
      return;
    }

    if (!this.showMultiIntentWarning()) {
      return this.checkIfTaggingNeededThenSendMessage();
    }
  }

  showPlatformAssignee() {
    return this.props.ticket && this.props.ticket.platformAssigneeName;
  }

  editorKeyBindingFn = (e) => {
    if ((e.metaKey && e.keyCode === KeyboardCode.Enter) || (e.ctrlKey && e.keyCode === KeyboardCode.S)) {
      return NewMessage.KEY_CMD_SEND_MESSAGE;
    }

    if (
      e.keyCode === KeyboardCode.LeftArrow ||
      e.keyCode === KeyboardCode.UpArrow ||
      e.keyCode === KeyboardCode.DownArrow
    ) {
      return this.removePredictionTextEvent();
    }

    if (e.keyCode === KeyboardCode.RightArrow) {
      return this.savePredictionTextEvent();
    }

    return getDefaultKeyBinding(e);
  };

  // This implementation disables keyboard support for italics, underline and bold formatting.
  handleKeyCommand = (command) => {
    if (command === NewMessage.KEY_CMD_SEND_MESSAGE) {
      this.handleSendMessage();
    }

    return 'not-handled';
  };

  handlePastedText = (text, html) => {
    const { selectedTicketId, clipboardText, user, ticket } = this.props;

    if (!clipboardText && !selectedTicketId && !user) {
      this.props.onPaste(text, html);

      return false;
    }

    const unFormatedText = htmlToText(html || text);
    // Remove any links to images that we can recognize as such.
    const sanitizedText = unFormatedText.replace(/https*:\/\/\S+\/\S+(\.png|\.jpg|\.jpeg|\.bmp|\.tiff|\.gif)/gi, '');
    const isImageRemoved = sanitizedText !== unFormatedText;

    const isTicketLiveChat = ticket && isLiveChat(ticket.communicationType);
    if (isTicketLiveChat) {
      this.props.onPaste(text, html);
      this.insertTextIntoMessage(sanitizedText);

      return 'handled';
    }

    // show popup only if more than 4 words are being pasted
    // to avoid showing popup on grammarly corrections
    const isMoreThanOneWord = typeof text === 'string' && text.split(' ').length >= 4;

    if (!user.isAdmin && isMoreThanOneWord && text !== clipboardText) {
      openOnTextPastePopup({
        onConfirm: (textSource) => {
          this.props.addNoteToSpecificTicket(
            `Expert has pasted the text to the message from ${textSource}\n${sanitizedText}`,
            selectedTicketId,
            SPECIALIST_ONLY_HINT
          );
          this.props.onPaste(text, html);
          this.insertTextIntoMessage(sanitizedText);
        },
      });
    } else if (isImageRemoved) {
      openOnTextPasteImageLinkRemoved({
        onConfirm: () => {
          this.props.onPaste(text, html);
          this.insertTextIntoMessage(sanitizedText);
        },
      });
    } else {
      this.props.onPaste(text, html);
      this.insertTextIntoMessage(sanitizedText);
    }

    // returning 'handled' prevents onEditorStateChange from triggering | Draft.js
    return 'handled';
  };

  checkSimilarity = (newMessageAsText, allMessagesIds, messages, skip) => {
    // skip check if clicked 'SEND ANYWAY'
    if (!skip) {
      const maxAllowedSimilarityRate = 0.85;
      for (const messageId of allMessagesIds) {
        const messageDirection = messages[messageId] && messages[messageId].direction;

        if (messageDirection === OUTBOUND) {
          const oldMessage = htmlToText(getTextFromPTagRegex(messages[messageId].messageBody));
          const similarityRate = stringSimilarity.compareTwoStrings(newMessageAsText, oldMessage);
          // if greater than 0.85 return number
          if (similarityRate > maxAllowedSimilarityRate) {
            return similarityRate;
          }
        }
      }
    }

    // isn't similar if similarity rate < 0.85
    return false;
  };

  toggleWarningMessage = () => {
    this.setState((previousState) => ({
      warningMessage: { text: '', iconName: '' },
      disableMultiIntentWarningMessage: previousState.warningMessage.text === NewMessage.warningMessageMultiIntent.text,
    }));
  };

  getConversationId = () => {
    return this.props.currentConversation && this.props.currentConversation.selectedConversationId;
  };

  getSimplrAccountObjectId = () => {
    const allMessages = this.props.currentConversation && this.props.currentConversation.allMessages;
    if (allMessages && allMessages.length) {
      return this.props.currentConversation[allMessages[0]].simplrAccountObjectId;
    }

    return null;
  };

  onChatMacroSelection = (chatMacro) => {
    if (chatMacro && chatMacro.text) {
      const { ticketType, communicationType } = this.props.ticket;
      const macro = messageToClientFormat(chatMacro.text, ticketType, communicationType);
      this.props.handleUseChatMacroRecommendation(chatMacro, () => this.insertTextIntoMessage(macro));
    }
  };

  isEmailCommerceWizardActive() {
    return this.props.isCommerceWizardActive && !isLiveChat(this.props.ticket.communicationType);
  }

  isSendButtonDisabled() {
    const { blockedWordsFound = [], overridableWordsFound = [] } = this.props?.currentConversation ?? {};

    return (
      !this.props.btnActivity.sendMessageBtn ||
      !!this.state.warningMessage.text ||
      !this.state.partnerTagsAreLoaded ||
      this.isEmailCommerceWizardActive() ||
      blockedWordsFound.length ||
      overridableWordsFound.length
    );
  }

  getWarningPopupSendAnyway() {
    // return null in cases where we want to disable ignore and sendanyway button
    if (this.state.warningMessage.text === NewMessage.warningMessageContainsEmojis.text) {
      return null;
    }

    return () => this.setState({ skipSimilarityCheck: true }, () => this.handleSendMessage());
  }

  render() {
    const { editorState, isTicketTranslated } = this.props;
    const { message, latestMessageId, ticketLoaded, ticket, shouldDisplayChatMacroRecommendations } = this.props;
    const { blockedWordsFound = [], overridableWordsFound = [] } = this.props?.currentConversation ?? {};
    const disableMessageBox = blockedWordsFound.length || overridableWordsFound.length;
    const editorPlaceholder = isTicketTranslated ? AUTO_TRANSLATED_EDITOR_USAGE_REPLY : EDITOR_USAGE_REPLY;

    let placeholderMsg = this.state.placeholderError ? 'Message required to send' : ``;
    placeholderMsg += placeholderMsg.length ? ':\n' + editorPlaceholder : editorPlaceholder;

    const emojiContainerJSX = (
      <EmojiContainer data-testid="emoji-container">
        <Emoji>
          <EmojiIcon src="/images/new-designs/emoji-icon-small.svg" onClick={this.onClickEmojiIconHandler} />
          {this.state.showEmoji && (
            <ClickOutside onClickOutside={this.onClickOutsideEmojiHandler}>
              <Picker
                style={{
                  position: 'absolute',
                  bottom: '65px',
                  left: '20px',
                  width: '400px',
                  zIndex: 5,
                }}
                emojiSize={18}
                sheetSize={16}
                color="#39BFD4"
                perLine={16}
                skin={1}
                native={true}
                autoFocus={true}
                exclude={['nature', 'flags', 'places', 'foods', 'symbols', 'custom']}
                set="emojione"
                onClick={(emoji) => this.insertTextIntoMessage(emoji.native)}
              />
            </ClickOutside>
          )}
        </Emoji>
      </EmojiContainer>
    );

    const bottomNoticeJSX = (
      <BottomNotice>
        {message.smbName && (
          <BusinessReminder textAreaExpanded={this.props.textAreaExpanded}>
            <BottomNoticeText commerceWizardActive={this.props.isCommerceWizardActive}>
              <b>Reminder:&#160;</b>
              you are answering on behalf of <span>{message.smbName}</span>
              {this.showPlatformAssignee() && ` as ${ticket.platformAssigneeName}`}
            </BottomNoticeText>
          </BusinessReminder>
        )}
        {editorState &&
          editorState.getCurrentContent().getPlainText().includes(COUPON_MASK_CHAR) &&
          'Your coupon code is attached.'}
      </BottomNotice>
    );

    return (
      <MessageBox
        name="MessageBox"
        key={message.conversationObjectId + '_' + latestMessageId}
        textAreaExpanded={this.props.textAreaExpanded}
      >
        <BotDialogBlockedWords
          show={ticketLoaded && blockedWordsFound.length}
          blockedWords={blockedWordsFound}
          onCancel={this.props.resetMessageConstraintsFound}
        />

        <BotDialogOverridableWords
          show={ticketLoaded && overridableWordsFound.length}
          busy={this.state.confirmedOverridableWords?.length}
          overridableWords={overridableWordsFound}
          onCancel={() => {
            trackAbortedNameOverride();
            this.props.resetMessageConstraintsFound();
          }}
          onConfirm={async (confirmedWords) => {
            try {
              const confirmedWordsString = confirmedWords.join(', ');
              trackBlockedNameOverride(confirmedWordsString);
              this.props.addNoteToSpecificTicket(
                `Specialist verified that they intended to send ${confirmedWordsString} on a ${this.props.message.smbName} ticket.`,
                this.props.selectedTicketId,
                SPECIALIST_ONLY_HINT
              );
              await this.setState({ confirmedOverridableWords: confirmedWords });
              await this.handleSendMessage({ bypassButtonState: true });
            } catch (err) {
            } finally {
              this.setState({ confirmedOverridableWords: [] });
            }
          }}
        />

        {this.isEmailCommerceWizardActive() && <CWNotification />}
        {shouldDisplayChatMacroRecommendations && ticketLoaded && (
          <ChatUI
            brand={this.props.ticket.brand}
            conversationId={this.getConversationId()}
            simplrAccountPtrId={this.getSimplrAccountObjectId()}
            onMacroPersistNotify={this.onChatMacroSelection}
            user={this.props.user}
            targetUserType={this.props.showChatMacroRecommendationsTargetUserType}
          />
        )}

        <MessageForm
          name="MessageForm"
          onSubmit={() => false}
          key={this.state.latestMessageId}
          className={'new-message-component'}
          textAreaExpanded={this.props.textAreaExpanded}
          // Make event handlers conditional
          onKeyDown={() => this.props.handleEscalationRecommendation()}
        >
          {/* Defer loading the textarea until we have loaded the ticket so we can set the defaultText properly */}
          {ticketLoaded && !this.isEmailCommerceWizardActive() && (
            <Wrapper name="Wrapper">
              <TextareaHolder name="TextareaHolder" textAreaExpanded={this.state.textAreaExpanded}>
                <TextareaBoxOuter
                  name="TextareaBoxOuter"
                  haveError={this.state.lengthError}
                  textAreaExpanded={this.state.textAreaExpanded}
                  disabled={disableMessageBox}
                  onKeyDown={this.sendMessageOnKeyPress}
                  data-testid="TextareaBoxOuter"
                >
                  <ErrorService.ErrorBoundary
                    customFields={{ system: 'Message Editor' }}
                    fallback={
                      <ErrorMessage>
                        Something went wrong. If you attempted to paste content, the editor may not support the data
                        pasted into it. Please refresh the page.
                      </ErrorMessage>
                    }
                  >
                    <GrammarlyEditorWrapper>
                      <Editor
                        editorState={editorState}
                        wrapperClassName="msg-editor-wrapper"
                        editorClassName="msg-editor"
                        key={message.conversationObjectId}
                        name="newMessage"
                        onEditorStateChange={(_editorState) => {
                          this.handleTextChangeEvent(_editorState);
                        }}
                        onTab={() => this.savePredictionTextEvent()}
                        onBlur={() => this.removePredictionTextEvent()}
                        onFocus={() => this.removePredictionTextEvent()}
                        keyBindingFn={this.editorKeyBindingFn}
                        handleKeyCommand={this.handleKeyCommand}
                        handlePastedText={this.handlePastedText}
                        handlePastedFiles={() => 'handled'}
                        handleDroppedFiles={() => 'handled'}
                        handleDrop={() => 'handled'} // Prevent drag-n-drop.
                        className="newMessageText"
                        data-message={JSON.stringify(message)}
                        placeholder={placeholderMsg}
                        id="largeMessageTextArea"
                        ref={this.setDomEditorRef}
                        textAlignment="left"
                        toolbarHidden={true}
                      />
                    </GrammarlyEditorWrapper>
                  </ErrorService.ErrorBoundary>
                  <IconContainer
                    data-testid="icon-container"
                    textAreaExpanded={this.state.textAreaExpanded}
                    commerceWizardActive={this.props.isCommerceWizardActive}
                  >
                    <ExpandIcon
                      src={
                        this.props.textAreaExpanded
                          ? '/images/new-designs/descale-icon.svg'
                          : '/images/new-designs/expand-icon.svg'
                      }
                      onClick={() => {
                        trackMessageWindowSizeChange(!this.props.textAreaExpanded);
                        this.onExpandClick();
                      }}
                    />
                    {!this.props.disableEmojis && emojiContainerJSX}
                  </IconContainer>
                </TextareaBoxOuter>
              </TextareaHolder>
            </Wrapper>
          )}
        </MessageForm>
        <BottomSection>
          <GrammarlyButtonWrapper />
          <FlexFill />
          {bottomNoticeJSX}
          <FlexFill />
          <div style={{ position: 'relative' }}>
            <SendButton
              label="SEND"
              buttonId={BUTTON_IDS.sendMessageBtn}
              fullColored={true}
              active={!this.isSendButtonDisabled()}
              onClick={() => this.handleSendMessage()}
              setBtnActivity={this.props.setBtnActivity}
              disabled={this.isSendButtonDisabled()}
            />
            <NewMessageWarningPopup
              show={!!this.state.warningMessage.text}
              toggle={this.toggleWarningMessage}
              sendAnyway={this.getWarningPopupSendAnyway()}
              warningMessage={this.state.warningMessage.text}
              iconName={this.state.warningMessage.iconName}
            />
          </div>
        </BottomSection>
      </MessageBox>
    );
  }
}

export default NewMessage;
